import { setDealTags } from '@helpers/deal.helper';
import { get } from './api.service';
import { URL_VOUCHER } from '@constants/api.constants';
import { IDeal } from '@interfaces/deal';

const endpointDeal = URL_VOUCHER;

export const getDeals = (merchantId: string) => {
	return get(`${endpointDeal}/v4/merchants/${merchantId}/merchant-app`).then((deals) => {
		deals?.data.forEach((deal: IDeal) => setDealTags(deal));
		return deals;
	});
};

export const getDealById = (dealId: string) => {
	return get(`${endpointDeal}/v3/${dealId}`).then((deal) => {
		deal.data = setDealTags(deal.data);
		return deal;
	});
};
